import { render, staticRenderFns } from "./UsersWithServiceInArea.vue?vue&type=template&id=5563ad50&scoped=true&"
import script from "./UsersWithServiceInArea.vue?vue&type=script&lang=js&"
export * from "./UsersWithServiceInArea.vue?vue&type=script&lang=js&"
import style0 from "./UsersWithServiceInArea.vue?vue&type=style&index=0&id=5563ad50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563ad50",
  null
  
)

export default component.exports